// Flags
import FlagEN from "@/assets/images/flags/united-kingdom.svg";
import FlagFI from "@/assets/images/flags/finland.svg";

// Application dictionaries
import appLocaleEN from "@/localization/locales/en.json";
import appLocaleFI from "@/localization/locales/fi.json";

// Validator dictionaries
import ValidatorLocaleEN from "vee-validate/dist/locale/en";
import ValidatorLocaleFI from "vee-validate/dist/locale/fi";

import uiKitEn from "@bi-book/bibook-ui-kit/src/locale/locales/en.json";

const locales = [
  {
    label: "English",
    value: "en",
    img: FlagEN,
    localeApp: {
      ...appLocaleEN,
      ...uiKitEn,
    },
    localeValidator: ValidatorLocaleEN,
    dateTimeFormats: {
      short: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
        hour: "numeric",
        minute: "numeric",
      },
    },
  },
  {
    label: "Finnish",
    value: "fi",
    img: FlagFI,
    localeApp: appLocaleFI,
    localeValidator: ValidatorLocaleFI,
    dateTimeFormats: {
      short: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
        hour: "numeric",
        minute: "numeric",
      },
    },
  },
];

export default locales;
